export default __webpack_public_path__ + "static/media/slider3.c57ea53a.png";